export default "__VITE_ASSET__s0Ot0qC___"